import { FBInputProps } from '../types/common';

export const DEVIATION_SERIAL_NUMBERS_KEY = 'deviation-serial-numbers';

export type FBAffectedSerialNumberProps =
& Pick<FBInputProps, 'name' | 'disabled'>;
